import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hotel-list-item-list" }
const _hoisted_2 = { key: 1 }

import HotelListItem from '@lmt-rpb/HotelListItem/HotelListItem.vue';
import Loading from '@lmt-rpb/Loading/Loading.vue';
import { getUniqueKey } from '@/components/common/services/bestOfferForHotelListService';
import type { ItemType } from '@/interfaces/hotel-list-types/hotel-list-types';
import type { DiscountHotelPriceOffer } from '@/interfaces/neusta-discount-price';

interface Props {
	items: ItemType[];
	loading?: boolean;
	showSuns?: boolean;
	hotelListType: string;
	discounts?: Map<string, DiscountHotelPriceOffer>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelListItemList',
  props: {
    items: {},
    loading: { type: Boolean, default: true },
    showSuns: { type: Boolean, default: false },
    hotelListType: {},
    discounts: { default: undefined }
  },
  setup(__props: any) {

const getDiscountKeyForOffer = (item: ItemType) => {
	const offerId = item.AccommodationOffer ? item.AccommodationOffer.OfferID : item.PackageOffer!.OfferID;
	const iffCode = item.Hotel.IffCode;

	return getUniqueKey({ offerId, iffCode });
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(Loading, {
          key: 0,
          class: "hotel-list-item-list__loader"
        }))
      : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(HotelListItem, {
                item: item,
                "item-index": index,
                "show-suns": _ctx.showSuns,
                "hotel-list-type": _ctx.hotelListType,
                discount: _ctx.discounts?.get(getDiscountKeyForOffer(item))
              }, null, 8 /* PROPS */, ["item", "item-index", "show-suns", "hotel-list-type", "discount"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
  ]))
}
}

})